module.exports = __webpack_public_path__ + "static/img/12003B_3_4_5_R_20190910_fit.393683e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/12003B_3_4_5_R_20190910_fit.png
// module id = trBx
// module chunks = 0